import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from '@material-ui/core';
import { API } from 'aws-amplify';
import useSnack from 'hooks/useSnack';
import Button from 'components/common/Button';

const NoteModal = ({ onClose, task }) => {
  const [text, setText] = React.useState('');
  const snack = useSnack();

  const onSendNote = async () => {
    try {
      return await API.post('api', '/users/send-todo-note', {
        body: {
          task,
          text,
        },
      }).then((res) => {
        snack.success('Note Sent');
        onClose();
      });
    } catch (e) {
      snack.error(e.message);
    }
  };

  return (
    <Dialog open onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>{task.title}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Send Note to {task?.assignedBy?.user_first_name}
        </DialogContentText>
        <TextField
          multiline
          autoFocus
          rows={3}
          margin="dense"
          id="name"
          label="note"
          type="text"
          fullWidth
          onChange={(e) => setText(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Cancel
        </Button>
        <Button onClick={onSendNote} color="primary">
          Send
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NoteModal;
